import { createAction, props } from "@ngrx/store";
import { LocationOption, NotificationDto, OperatorOption } from "./header.models";
import { MenuItem } from "primeng/api";

// export const loadOperators = createAction('[Header] Load operators');
// export const operatorsLoadSuccess = createAction('[Header] Operators load success', props<{ operators: OperatorOption[], defaultOperatorId: string | undefined }>());

export const loadLocations = createAction('[Header] Load locations', props<{ operator: OperatorOption | null }>());
export const locationsLoadSuccess = createAction('[Header] Locations load success', props<{ locations: LocationOption[] }>());

export const loadNotifications = createAction('[Header] Load notifications');
export const notificationsLoadSuccess = createAction('[Header] Notifications load success', props<{ notifications: NotificationDto[] }>());

export const loadMenuItems = createAction('[Header] Load menu items');
export const loadMenuItemsSuccess = createAction('[Header] Menu items load success', props<{menuItems: MenuItem[]}>());